module.exports = __webpack_public_path__ + "media/opi-asippindo.3126d906.mp4";